module.exports = __webpack_public_path__ + "static/img/manual_ja_22.894f1e1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/ja/manual_ja_22.png
// module id = aM9c
// module chunks = 4